import { gql } from "@apollo/client";
import { PROGRAM_HISTORY_WITH_SPECIALIST, PROGRAM_HISTORY_INFO } from "graphql-client/fragments";

export const GET_TREATMENT_HISTORY = gql`
  query GetTreatmentHistory($accountId: Int!) {
    treatmentHistory: programHistory(account_id: $accountId) {
      ...ProgramHistoryWithSpecialist
    }
  }
  ${PROGRAM_HISTORY_WITH_SPECIALIST}
`;

export const GET_LATEST_PROGRAM = gql`
  query GetLatestProgram($accountId: Int!) {
    getLatestProgram(account_id: $accountId) {
      ...ProgramHistoryInfo
    }
  }
  ${PROGRAM_HISTORY_INFO}
`;
